import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./styles/app.scss";
import { signOut, storeCredentials } from "./redux/auth/authActions";
import { clearMenuData } from "./redux/menu/menuAction";
import { ToastContainer } from "react-toastify";
import { RootState } from "./redux/rootReducer";
import Routers from "../src/Routers";
import { Contextpage } from "pages/productCatalog/contextpage";
import MainPage from "pages/productCatalog/MainPage/MainPage";
import { clearReportData } from "redux/newReports/newReportsActions";
import { authStorage } from "./util/authStorage";
import { getSessionContext } from "./redux/api";
import RedirectNotice from "./components/RedirectNotice";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement);

// Set the font globally for all charts
ChartJS.defaults.font.family = "'Poppins', sans-serif";
interface Credentials {
  accessToken: string;
  address: string;
  attributes: string;
  authUserId: string;
  blockUser: boolean;
  businessName: string;
  dateOfBirth: string;
  defaultDeviceId: string;
  defaultFunctionalityAccessUpdated: boolean;
  deviceIdentifier: string;
  devicePin: number;
  deviceType: string;
  education: string;
  email: string;
  favoriteTables: string[];
  firstName: string;
  fullName: string;
  id: string;
  isSuperAdminAccess: boolean;
  isTempPassword: boolean;
  lastName: string;
  locationId: string;
  merchantId: string;
  mobileNumber: string;
  myTableViewSectionExists: boolean;
  nickName: string;
  outlet: string;
  password: string;
  refreshToken: string;
  role: string;
  toUseNickName: boolean;
  topicToSubscribe: string;
  userAccessInfoList: string;
  userId: string;
}

const Loader = ({ onReady }: { onReady: () => void }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const initSession = async () => {
      const cookieCredentials = authStorage.getCredentials();
      if (cookieCredentials) {
        try {
          // Call session context API — HttpOnly cookies are sent automatically.
          // Returns: { id, merchantId, locationId, businessName, topicToSubscribe, userId, accessToken, refreshToken }
          const response = await getSessionContext();
          const sessionData = response?.data?.metaDataInfo?.data || response?.data;
          // Merge cookie profile data with session context data
          const fullCredentials = { ...cookieCredentials, ...sessionData };
          dispatch(storeCredentials(fullCredentials));
        } catch (error) {
          // Session expired or invalid — clear and redirect to login
          authStorage.clear();
          dispatch(signOut());
        }
      }
      onReady();
    };
    initSession();
  }, []);
  return <span></span>;
};

// Maghil -> Brisque migration: when true, every page shows the redirect notice
// and forwards to the new portal. Set to false to restore the legacy portal.
const MIGRATION_REDIRECT = true;

const App = () => {
  return MIGRATION_REDIRECT ? <RedirectNotice /> : <LegacyApp />;
};

const LegacyApp = () => {
  const [sessionReady, setSessionReady] = useState(false);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--wHeight",
      window.innerHeight + "px"
    );

    document.documentElement.style.setProperty(
      "--wWidth",
      window.innerWidth + "px"
    );
  }, []);

  const authState = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (!sessionReady) return;
    const fetchData = async (): Promise<void> => {
      const credentials = authState?.credentials as Credentials | null;
      if (!credentials?.role) {
        dispatch(clearMenuData());
        dispatch(clearReportData());
        authStorage.clear();
        dispatch(signOut());
        history.replace("/");
      }
    };
    fetchData();
  }, [authState?.credentials, sessionReady]);

  return (
    <>
      <Loader onReady={() => setSessionReady(true)} />
      <div className="app">
        <div className="main-section">
          <ToastContainer autoClose={3000} limit={1}/>
          <Routers />
        </div>
      </div>
    </>
  );
};

export default App;

// Restaurant_Owner, Restaurant_Manager, System_Admin, Owner, Cashier,Supervisor, Waiter, Host, Employee
